import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link, useNavigate, useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import Productlist from "./Productlist";
// import Productgrid from "./Productgrid";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import {
  getAllProductDetailslist,
  getInvoiceSupplierList,
  // getSegmentList,
  getUnspcAdd,
  getActiveProduct,
  getFamilyList,
  getClassList,
  getCommodityUnspcList,
  updateBaseQty,
  addUNSPSCPastOrder,
  addUnspscData,
} from "../../../service/Product/ProductService";
import {
  deleteSegment,
  getAddSegment,
  getAddSegmentToAll,
  getSegmentAdd,
  getSegmentList,
  getSegmentUnspcAdd,
  getFamilyUnspcAdd,
  getClassUnspcAdd,
  searchUnspc,
  searchUnspcGlobal,
  getSelectedUnspscDetails,
} from "../../../service/Segment/SegmentService";
import { Card, Tooltip, OverlayTrigger, Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SpinnerComponent from "../../components/SpinnerComponent";
// import Checkbox from "../components/Checkbox";
import moment from "moment";
// import Multiselect from "./Multiselect";
// import {searchUnspc} from '../../../service/Segment/SegmentService'
import * as _ from "lodash";
import { useTranslation } from "react-i18next";
import debounce from "lodash/debounce";

const TreeItem = ({ title, children, onClick, isOpen, toggleOpen }) => {
  return (
    <div style={{ marginLeft: "20px" }}>
      <div style={{ display: "flex", margin: "5px" }}>
        <div
          onClick={toggleOpen}
          style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
        >
          {!title.startsWith("Commodity Code") && (
            <span style={{ marginRight: "5px" }}>{isOpen ? "−" : "+"}</span>
          )}
          {title}
        </div>
        {/* {<ConditionalContent />} */}

        {/* {!title.startsWith("Segment Code") && (
          <div>
            <Button
              variant="success"
              style={{
                height: "24px",
                padding: "1px 2px",
                marginLeft: "5px",
              }}
            >
              GL Key
            </Button>
          </div>
        )} */}
      </div>

      {isOpen && <div>{children}</div>}
    </div>
  );
};

const SearchAllUNSPSC = () => {
  const location = useLocation();
  const { selected } = location.state || {}; // `selected` will be undefined if state is not passed

  //Search
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalSearchResult, setTotalSearchResult] = useState(0);
  const [search, setSearch] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchResultsEnd, setSearchResultsEnd] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [selectedSearchResult, setSelectedSearchResult] = useState("");

  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isToggled, setToggled] = useState(true);
  const [isToggleddata, setToggleddata] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  // const [toggleCo2,setToggleCo2] = useState(true);
  const [searchOptions, setSearchOptions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const handleToggle = () => {
    setToggled(!isToggled);
  };

  const handleToggledata = () => {
    setToggleddata(!isToggleddata);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      !isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const afterUpdateUnspschandledata = () => {
    // setToggleddata(!isToggleddata);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
    //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(true);
  const [getProductId, setProductId] = useState([]);
  const [invoiceSupplierDataList, setAllInvoiceSupplierDataList] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [vat, setVat] = useState("");
  const [month, setMonth] = useState("");
  const [showUnspc, setShowUnspc] = useState(false);
  const [getSegmentCode, setGetSegmentCode] = useState([]);
  const [allAllDataList, setAllDataList] = useState([]);
  const [segmentCode, setSegmentCode] = useState("");
  const [addProductId, setAddProductId] = useState("");
  // const [selected, setSelected] = useState([]);

  const [allUnspcList, setAllUnspcList] = useState([]);
  const [familyList, setFamilyList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [commodityList, setCommodityList] = useState([]);

  const [segmentData, setSegmentData] = useState({});
  const [familyData, setFamilyData] = useState({});
  const [classData, setClassData] = useState({});
  const [commodityData, setCommodityData] = useState({});

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [finalStartDate, setFinalStartDate] = useState("");
  const [finalEndDate, setFinalEndDate] = useState("");
  const [segmentDataList, setAllSegmentDataList] = useState([]);
  const [getDataSegment, setDataSegment] = useState("");
  const [allUnspcFamily, setUnspcFamily] = useState([]);
  const [allUnspcClass, setUnspcClass] = useState([]);
  const [allUnspcComodity, setUnspcComodity] = useState([]);
  const [getDataFamily, setDataFamily] = useState("");

  const [openSegment, setOpenSegment] = useState(null);
  const [openFamily, setOpenFamily] = useState(null);
  const [openClass, setOpenClass] = useState(null);

  const handleSegmentClick = (segment) => {
    setOpenSegment(openSegment === segment ? null : segment);
    if (onDataSegment) onDataSegment(segment);
  };

  const handleFamilyClick = (segment, family) => {
    setOpenFamily(openFamily === family ? null : family);
    setOpenClass(null); // Close all classes when a new family is opened
    if (onDataFamily) onDataFamily(family);
  };

  const handleClassClick = (family, classItem) => {
    setOpenClass(openClass === classItem ? null : classItem);
    if (onDataClass) onDataClass(classItem);
  };

  const handleClose = () => {
    setShow(false);
  };
  const handleCloseUnspc = () => {
    setFamilyList([]);
    setClassList([]);
    setCommodityList([]);
    setSegmentData({});
    setFamilyData({});
    setClassData({});
    setCommodityData({});
    setShowUnspc(false);
  };

  const _GET_FAMILY_DATA = (data) => {
    setSegmentData(data);
    getFamilyList(data.value, (res) => {
      setFamilyList(
        res.data.listUnspsc.map((item) => {
          return { id: item.id, value: item.Family, label: item.FamilyTitle };
        })
      );
    });
  };
  const _GET_CLASS_DATA = (data) => {
    setFamilyData(data);
    getClassList(segmentData.value, data.value, (res) => {
      setClassList(
        res.data.listUnspsc.map((item) => {
          return { id: item.id, value: item.Class, label: item.ClassTitle };
        })
      );
    });
  };
  const _GET_COMMODITY_DATA = (data) => {
    setClassData(data);
    getCommodityUnspcList(
      segmentData.value,
      familyData.value,
      data.value,
      (res) => {
        setCommodityList(
          res.data.listUnspsc.map((item) => {
            return {
              id: item.id,
              value: item.Commodity,
              label: item.CommodityTitle,
            };
          })
        );
      }
    );
  };
  const _SET_FINAL_DATA = (data) => {
    setCommodityData(data);
  };
  //   getCommodityUnspcList
  const clickpage = () => {
    navigate("/productdetails");
  };

  const searchPage = () => {
    navigate("/search-all-unspsc");
  };

  useEffect(() => {
    getallProductList();
    getInvoiceSupplierDataList();
    getSegmentAddList();
  }, []);

  const handleActive = (id, isActive) => {
    getActiveProduct("Product", id, isActive ? false : true, (r) => {
    //  console.log(r, "response");
      if (r.success === true) {
        getallProductList();
      } else {
        // toast.error(r.message)
      }
    });
  };

  async function getSegmentAddList() {
    getSegmentList().then(function (result) {
      const response = result.data;
      setAllUnspcList(
        response?.data?.segmentList.map((item) => {
          return { id: item.id, value: item.Segment, label: item.SegmentTitle };
        })
      );
      setAllSegmentDataList(response?.data?.segmentList);
    });
  }

  async function getallProductList() {
    getAllProductDetailslist("").then(function (result) {
      const response = result.data;
      // console.log(response, "response");
      setProductId(response?.data?.listProduct);
    //  console.log(response?.data?.listProduct.length, "papu");
      // setDepartmentId(response?.data?.businessUnit?.Departments);
    });
  }

  async function getInvoiceSupplierDataList() {
    getInvoiceSupplierList().then(function (result) {
      const response = result?.data;
      setAllInvoiceSupplierDataList(response?.data?.SuppliersList);
    });
  }

  const onSuppliers = (e) => {
    const ArrSup = e ? e : [];
    supplier.push(e);
    setSupplier(supplier);

    getAllProductDetailslist(
      ArrSup,
      vat,
      month,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
    //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const onVat = (e) => {
    setVat(e.target.value);
    getAllProductDetailslist(
      supplier,
      e.target.value,
      month,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
    //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const onMonth = (e) => {
    setMonth(Number(e.target.value ? e.target.value : 12));
    getAllProductDetailslist(
      supplier,
      vat,
      e.target.value ? Number(e.target.value) : 12,
      isToggleddata,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
    //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const onSearch = (e) => {
    setSearch(e.target.value);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      e.target.value,
      finalStartDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
    //  console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  // const onUnspc = (e, data = "") => {
  //   e.preventDefault();
  //   setShowUnspc(true);
  //   if (data) {
  //     setSelected([data]);
  //   }
  // };

  const onSegment = (e, index) => {
    // {value: 10000000, label: 'Live Plant and Animal Material and Accessories and Supplies'}
    setSegmentCode(e.target.value);
    const segmentfilterData = allUnspcList.filter(
      (item) => item.Segment === Number(e.target.value)
    );
    setGetSegmentCode(segmentfilterData[0]?.SegmentTitle);
    // getAddSegmentToAll(e.target.value).then(function (result) {
    //   const response = result.data;
    //   setAllDataList(response?.data);
    // });
  };

  const onAddUnspc = (e) => {
    e.preventDefault();
    // console.log(selected)
    if (commodityData.value) {
      getUnspcAdd(
        commodityData,
        // commodityData.label,
        selected,
        "Commodity",
        (r) => {
          if (r.success === true) {
            toast.success(r.message);
            setShowUnspc(false);
            setSegmentCode("");
            afterUpdateUnspschandledata();
          } else {
            toast.error(r.message);
          }
        }
      );

      // for (const iterator of selected) {
      //     unspscPayload.push({productId:iterator.id,unspsc:commodityData.value,point:'commodity'});
      // }
    } else if (classData.value) {
      getUnspcAdd(classData, selected, "Class", (r) => {
        if (r.success === true) {
          toast.success(r.message);
          setShowUnspc(false);
          setSegmentCode("");
          afterUpdateUnspschandledata();
        } else {
          toast.error(r.message);
        }
      });
    } else if (familyData.value) {
      getUnspcAdd(familyData, selected, "Family", (r) => {
        if (r.success === true) {
          toast.success(r.message);
          setShowUnspc(false);
          setSegmentCode("");
          afterUpdateUnspschandledata();
        } else {
          toast.error(r.message);
        }
      });
    } else if (segmentData.value) {
      getUnspcAdd(segmentData, selected, "Segment", (r) => {
        if (r.success === true) {
          toast.success(r.message);
          setShowUnspc(false);
          setSegmentCode("");
          afterUpdateUnspschandledata();
        } else {
          toast.error(r.message);
        }
      });
    } else {
      toast.error("Please select at least one unspsc");
    }

    setFamilyList([]);
    setClassList([]);
    setCommodityList([]);
    setSegmentData({});
    setFamilyData({});
    setClassData({});
    setCommodityData({});
    setShowUnspc(false);
  };

  const onRemoveUnspc = (e) => {
    e.preventDefault();
    if (classData.value) {
      setClassData({});
      setCommodityData({});
    } else if (familyData.value) {
      setFamilyData({});
    } else if (segmentData.value) {
      setSegmentData({});
    }
  };

  function handleSelect(value, name) {
    // console.log(value)
    // console.log(name)
    // if (value) {
    //   setSelected([...selected, name]);
    // } else {
    //   setSelected(selected.filter((item) => item !== name));
    // }
    // selected.some((item) => item.id === name.id)
    //   ? setSelected(selected.filter((item) => item !== name))
    //   : setSelected([...selected, name]);
  }

  // function selectAll(value) {
  //   if (value) {
  //     let tempGetProductId = getProductId.filter((item) => !item.unspsc);
  //     setSelected(tempGetProductId);
  //   } else {
  //     setSelected([]);
  //   }
  // }

  const onFromDate = (e) => {
    setStartDate(e);
    // console.log(e, "eeeeeeeeeeeeeee")
    const fromDate = moment(e).format("DD-MM-YYYY");
    // console.log(fromDate, "fromDate");
    setFinalStartDate(fromDate);
    // setSearch(e.target.value);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      isToggleddata,
      fromDate,
      finalEndDate
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const onToDate = (e) => {
    setEndDate(e);
    const toDate = moment(e).format("DD-MM-YYYY");
    setFinalEndDate(toDate);
    getAllProductDetailslist(
      supplier,
      vat,
      month,
      isToggleddata,
      isToggleddata,
      finalStartDate,
      toDate
    ).then(function (result) {
      const response = result?.data;
      // console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const _RESET = (e) => {
    e.preventDefault();
    setSearch("");
    // setBusinessUnit("");
    setSupplier([]);
    setFinalStartDate("");
    setFinalEndDate("");
    setStartDate("");
    setEndDate("");
    setMonth("");
    setVat("");
    setToggleddata(false);
    setSelectedOptions([]);
    getAllProductDetailslist("", "", "", false, false, "", "").then(function (
      result
    ) {
      const response = result?.data;
      // console.log(response, "rrrr");
      setProductId(response?.data?.listProduct);
    });
  };

  const [qtyData, setQtyData] = useState({
    productId: null,
    BaseQuantity: "",
  });

  const _UPDATE_VALUE = (e, d) => {
    e.preventDefault();
    setQtyData({ productId: d.id, BaseQuantity: e.target.value });
  };

  const _SAVE_QTY = (e, d) => {
    e.preventDefault();
    if (d.id === qtyData.productId) {
      updateBaseQty(qtyData, (res) => {
        getallProductList();
        toast.success(res.message);
      });
    } else {
      updateBaseQty(
        { productId: d.id, BaseQuantity: d?.item?.InvoicedQuantity?._text },
        (res) => {
          getallProductList();
          toast.success(res.message);
        }
      );
    }
  };

  // Function to convert the array of objects
  function convertToArrayOfObjects(array) {
    const result = [];
    for (let index = 0; index < array.length; index++) {
      // if(result.some(item=>item.label===result.label)){
      result.push({
        value: {
          code: array[index].Segment,
          point: "Segment",
          title: array[index].SegmentTitle,
          id: array[index].id,
        },
        label: `${array[index].SegmentTitle} ( Segment - ${array[index].Segment})`,
      });
      // }
      result.push({
        value: {
          code: array[index].Family,
          point: "Family",
          title: array[index].FamilyTitle,
          id: array[index].id,
        },
        label: `${array[index].FamilyTitle} ( Family - ${array[index].Family})`,
      });
      result.push({
        value: {
          code: array[index].Class,
          point: "Class",
          title: array[index].ClassTitle,
          id: array[index].id,
        },
        label: `${array[index].ClassTitle} ( Class - ${array[index].Class})`,
      });
      result.push({
        value: {
          code: array[index].Commodity,
          point: "Commodity",
          title: array[index].CommodityTitle,
          id: array[index].id,
        },
        label: `${array[index].CommodityTitle} ( Commodity - ${array[index].Commodity})`,
      });
    }
    let jsonObject = result.map(JSON.stringify);
    let uniqueSet = new Set(jsonObject);
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
    // console.log(res1,"res1")
    setSearchOptions(uniqueArray);
    // return uniqueArray;
  }

  // const _SEARCH_UNSPSC = _.debounce((data) => {
  //   searchUnspcGlobal(data, (res) => {
  //     // console.log('hhhhhhhhhhh')
  //     // console.log(res.data,"data")
  //     setSearchOptions([]);
  //     convertToArrayOfObjects(res.data);
  //   });
  // }, 500);

  const _SELECT_UNSPSC = (data) => {
    // console.log(data,"myData");
    setLoading(true);
    getUnspcAdd(data, selected, (r) => {
      if (r.success === true) {
        toast.success(r.message);
        setShowUnspc(false);
        setSegmentCode("");
        afterUpdateUnspschandledata();
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(r.message);
      }
    });
  };

  const onDataSegment = (e) => {
    // console.log(e, "sesesegegegege")
    setDataSegment(e);
    getSegmentUnspcAdd(e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcFamily(r?.data?.listUnspsc);

        // toast.success(r.message)
      } else {
        toast.error(r.message);
      }
    });
  };

  const onDataFamily = (e) => {
    // console.log(e, "sesesegegegege")
    setDataFamily(e);

    getFamilyUnspcAdd(getDataSegment, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcClass(r?.data?.listUnspsc);

        // toast.success(r.message)
      } else {
        toast.error(r.message);
      }
    });
  };

  const onDataClass = (e) => {
    // console.log(e, "sesesegegegege")
    setDataFamily(e);

    getClassUnspcAdd(getDataSegment, getDataFamily, e, (r) => {
      if (r.success === true) {
        // setAllIndustryId('');
        setUnspcComodity(r?.data?.listUnspsc);

        // toast.success(r.message)
      } else {
        toast.error(r.message);
      }
    });
  };

  // Search Section
  const searchUnspsc = debounce((input) => {
    setSearch("");
    setPage(1);
    setTotalSearchResult(0);
    setSearchResults([]);

    if (!input) {
      return;
    }

    setSearch(input);
  }, 1500);

  const loadMoreResults = () => {
    setPage(page + 1);
  };

  function getSearchResults() {
    setIsSearchLoading(true);

    searchUnspc(search, page, "user", (res) => {
      if (!res.data || res.data.results.length === 0) {
        setSearchResults([]);
        setIsSearchLoading(false);
        return;
      }

      setSearchResults((prevResults) => [...prevResults, ...res.data.results]);
      setTotalSearchResult(res.data.total);
      setSearchResultsEnd(res.data.reachedEnd);
      setIsSearchLoading(false);
    });
  }

  function getUnspscData(result) {
    toast.dismiss();

    toast.warning(
      <div className="toast-content">
        <div className="toast-message">
          Are you sure you want to add this UNSPSC Number?
        </div>
        <div className="button-container">
          <button
            className="yes-button"
            onClick={() => {
              getSelectedUnspscDetails(result, (res) => {
                if (res.success) {
                  // console.log("res");
                  // console.log(res);
                  // console.log(selected);

                  // const data = {
                  //   value: {
                  //     id: res.data.details.id,
                  //     title: res.data.details.title,
                  //     code: res.data.details.code,
                  //     point: res.data.details.point,
                  //   },
                  // };

                  addUnspscData(res.data.details, selected, (response) => {
                    if (response.success === true) {
                      toast.success(response.message);
                      // setPage(1);
                      // setSearchResults([]);
                      // setSearch("");
                      // getallPastOrderList();
                      // setSelected([]);
                      // handleCloseUnspc();
                    } else {
                      toast.error(response.message);
                    }
                  });
                }
              });
            }}
          >
            Yes
          </button>
          <button
            className="no-button ms-2"
            onClick={() => {
              toast.dismiss();
            }}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: true,
        closeOnClick: true,
      }
    );
  }

  useEffect(() => {
    getSearchResults();
  }, [search]);

  useEffect(() => {
    if (page > 1) {
      getSearchResults();
    }
  }, [page]);

  return (
    <div className="container-fluid">
      <div className="dbMain ghgbg">
        <Leftpanel />
        <div className="dbRight">
          <Header link="/dashboard" title="Search All UNSPSC" description="" />
          <div className="commonBase mb-4">
            {/* <input type="text" className='form-control' placeholder='Search UNSPSC...' /> */}
            {/* <Select
              options={searchOptions}
              // onChange={_GET_CLASS_DATA}
              placeholder={"Search UNSPSC..."}
              // isDisabled={familyData.value}
              noOptionsMessage={() => "Type something UNSPSC specific"}
              onChange={_SELECT_UNSPSC}
              onInputChange={_SEARCH_UNSPSC}
              components={{
                DropdownIndicator: () => null,
                IndicatorSeparator: () => null,
              }}
            /> */}

            <div className="searchParentDiv">
              <div>
                <input
                  className="productSearch py-2 px-4"
                  type="search"
                  placeholder="Type something to search..."
                  onChange={(e) => searchUnspsc(e.target.value)}
                />
              </div>
              {search && (
                <div className="searchResults">
                  {searchResults && searchResults.length > 0 ? (
                    <>
                      {searchResults.map((result, index) => (
                        <div
                          className="form-check d-flex justify-content-between"
                          key={index}
                          onClick={() => getUnspscData(result)}
                        >
                          <div>
                            {index +
                              1 +
                              ". " +
                              result.value +
                              " (" +
                              result.belongsTo +
                              " " +
                              result.key +
                              ")"}
                          </div>
                          <div>
                            <i
                              className="fa fa-plus theme-color"
                              aria-hidden="true"
                              title="Click to Add"
                            ></i>
                          </div>
                        </div>
                      ))}

                      {/* Load More Button */}
                      {totalSearchResult > searchResults.length && (
                        <div className="load-more d-flex justify-content-center">
                          {isSearchLoading ? (
                            <button disabled>
                              <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                            </button>
                          ) : (
                            !searchResultsEnd && (
                              <button onClick={loadMoreResults}>
                                Load More
                              </button>
                            )
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <div className="form-check" style={{ textAlign: "center" }}>
                      {isSearchLoading ? (
                        <i className="fa-solid fa-spinner fa-spin"></i>
                      ) : (
                        "No Result Found"
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            {isLoading && <SpinnerComponent isLoading={isLoading} />}
            <h2 className="d-flex justify-content-center">OR</h2>
            {/* <h5 className='mt-4 mb-3'>UNSPSC :</h5> */}
            <div className="accordion unspscAccord" id="unAccordion">
              <div className="accordion-item">
                {segmentDataList
                  .sort((a, b) => a?.Segment - b?.Segment)
                  ?.map((segment) => (
                    <TreeItem
                      key={segment.Segment}
                      title={t("segment_code", {
                        segment: segment.Segment,
                        title: segment.SegmentTitle,
                      })} // Use translation
                      isOpen={openSegment === segment.Segment}
                      toggleOpen={() => handleSegmentClick(segment.Segment)}
                      onClick={onDataSegment.bind(
                        segment?.Segment,
                        `${segment?.Segment}`
                      )}
                    >
                      {allUnspcFamily?.map((family) => (
                        <TreeItem
                          key={family.Family}
                          title={t("family_code", {
                            family: family.Family,
                            title: family.FamilyTitle,
                          })} // Use translation
                          isOpen={openFamily === family.Family}
                          toggleOpen={() =>
                            handleFamilyClick(segment.Segment, family.Family)
                          }
                          onClick={onDataFamily.bind(
                            family?.Family,
                            `${family?.Family}`
                          )}
                        >
                          {allUnspcClass?.map((classItem) => (
                            <TreeItem
                              key={classItem.Class}
                              title={t("class_code", {
                                class: classItem.Class,
                                title: classItem.ClassTitle,
                              })} // Use translation
                              isOpen={openClass === classItem.Class}
                              toggleOpen={() =>
                                handleClassClick(family.Family, classItem.Class)
                              }
                              onClick={onDataClass.bind(
                                classItem?.Class,
                                `${classItem?.Class}`
                              )}
                            >
                              {allUnspcComodity?.map((commodity) => (
                                <TreeItem
                                  key={commodity.Commodity}
                                  title={t("commodity_code", {
                                    commodity: commodity.Commodity,
                                    title: commodity.CommodityTitle,
                                  })} // Use translation
                                />
                              ))}
                            </TreeItem>
                          ))}
                        </TreeItem>
                      ))}
                    </TreeItem>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchAllUNSPSC;
